// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { lastDayOfISOWeek as fn } from "../lastDayOfISOWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const lastDayOfISOWeekWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default lastDayOfISOWeekWithOptions;
